import Vue from 'vue';
import DatatableHeader from './datatable-header.vue';

Vue.component('datatable-header', DatatableHeader);
